import {HttpClient, ClientConfig} from '../../http';

import {
  GetFootDataFileRequest,
  GetFootDataFileResponse,
  GetFootDataFilesRequest,
  ReprocessFootDataRequest,
  ReprocessFootDataResponse,
  GetFootDataFilesResponse
} from '@stryd/models';

const basePath = `/b/admin/users`;

export const setupFootDataEndpoints = (client: HttpClient) => {
  return {
    getFootDataFiles: (
      {userId, from, to, limit}: GetFootDataFilesRequest,
      config?: ClientConfig
    ) => {
      return client.get<GetFootDataFilesResponse, {message: string}>(
        `${basePath}/${userId}/foot-data/files?from=${from}&to=${to}&limit=${limit}`,
        config
      );
    },
    getFileById: (
      {userId, id, includeContent = true}: GetFootDataFileRequest,
      config?: ClientConfig
    ) => {
      return client.get<GetFootDataFileResponse, string>(
        `${basePath}/${userId}/foot-data/files/${id}?include_content=${includeContent}`,
        config
      );
    },
    reprocessFootData: (
      {userId, id, complete}: ReprocessFootDataRequest,
      config?: ClientConfig
    ) => {
      return client.post<ReprocessFootDataResponse, {message: string}>(
        `${basePath}/${userId}/foot-data/files/${id}/reprocess`,
        {complete},
        config
      );
    },
  };
};
